import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faFileAlt, faMapMarkerAlt, faVideo } from '@fortawesome/free-solid-svg-icons';

const headerIconMap = {
  IMAGE: faImage,
  VIDEO: faVideo,
  DOCUMENT: faFileAlt,
  LOCATION: faMapMarkerAlt,
};

const TemplateCard = ({ template }) => {
  const parsed = useMemo(() => {
    if (!template?.code) return { components: [] };
    try {
      return JSON.parse(template.code);
    } catch (err) {
      console.warn('Unable to parse template.code', err);
      return { components: [] };
    }
  }, [template?.code]);

  const components = parsed?.components || [];
  const header = components.find((c) => c.type === 'HEADER');
  const body = components.find((c) => c.type === 'BODY');
  const footer = components.find((c) => c.type === 'FOOTER');
  const buttons = components.find((c) => c.type === 'BUTTONS');

  const headerIsText = header?.format === 'TEXT' && header?.text;
  const headerIcon = header && headerIconMap[header.format];
  const buttonList = Array.isArray(buttons?.buttons) ? buttons.buttons : [];

  const renderHeader = () => {
    if (!header) return null;
    if (headerIsText) {
      return <div className="template-card__header-text">{header.text}</div>;
    }

    const label = header?.format ? header.format.replace(/_/g, ' ').toLowerCase() : 'media header';
    return (
      <div className="template-card__header-media">
        {headerIcon ? <FontAwesomeIcon icon={headerIcon} /> : null}
        <span>{label}</span>
      </div>
    );
  };

  return (
    <div className="template-card">
      <div className="template-card__preview">
        <div className="template-card__bubble">
          {renderHeader()}
          <div className="template-card__body">{body?.text || 'No body content'}</div>
          {footer?.text ? <div className="template-card__footer">{footer.text}</div> : null}
        </div>
        {buttonList.length > 0 && (
          <div className="template-card__buttons">
            {buttonList.map((btn, idx) => (
              <button key={idx} type="button" className="template-card__button">
                <span className="template-card__button-text">{btn?.text || `Button ${idx + 1}`}</span>
                {btn?.type ? (
                  <span className="template-card__button-meta">{btn.type.replace(/_/g, ' ').toLowerCase()}</span>
                ) : null}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="template-card__meta">
        <h3 className="template-card__title" title={parsed?.name || template?.name || 'Unnamed Template'}>
          {parsed?.name || template?.name || 'Unnamed Template'}
        </h3>
        <div className="template-card__tags">
          <span className="template-card__tag">{template?.wa_template_category || 'Uncategorised'}</span>
          <span className={`template-card__status status-${(template?.wa_template_status || 'unknown').toLowerCase()}`}>
            {template?.wa_template_status || 'Unknown'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
